// Journey track content — the single source for stages, tasks and the quiz.
// Served by GET /journey/content from the stand's feature-overlay pack
// (redmine #4480: the expert edits content via the sync, no code deploys),
// public so the quiz can run before registration.
import { api } from '../../../api/client'

export interface JourneyTaskDef {
  id: string
  title: string
  why?: string
  steps: string[]
  kind?: string
}

export interface JourneyStageDef {
  id: string
  no: number
  phase?: string
  title: string
  user_text: string
  focus?: string
  transition_text?: string
  checklist: string[]
  sos: string[]
  weekly_tasks?: JourneyTaskDef[]
  daily_tasks?: JourneyTaskDef[]
}

export interface QuizAnswerDef {
  id: string
  text: string
  next?: unknown
  // stage markers ride answers; 'none' means the quiz could not determine one
  stage?: number | string
}

export interface QuizQuestionDef {
  id: string
  text: string
  pass_to_bot?: string
  answers: QuizAnswerDef[]
}

export interface JourneyContent {
  version: string
  track: string
  stages: JourneyStageDef[]
  quiz: {
    intro: string
    start: string
    questions: QuizQuestionDef[]
    result_text: string
    undetermined_text: string
    tags: { stage: string; stage_none: string; answer: string }
  }
  ui: Record<string, string>
}

let cache: Promise<JourneyContent> | null = null

export function loadJourneyContent(): Promise<JourneyContent> {
  cache ??= api.get<JourneyContent>('/journey/content', { auth: false }).catch((error: unknown) => {
    cache = null
    throw error
  })
  return cache
}

export function stageByNo(content: JourneyContent, no: number): JourneyStageDef | null {
  return content.stages.find((stage) => stage.no === no) ?? null
}

export function renderTemplate(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match)
}
